import { IS_NATIVE } from "../config.js";
import { loadBrowser } from "./plugins.js";

/**
 * Open a URL outside the app's own WebView. `window.open` is swallowed by WKWebView, so
 * checkout would simply do nothing natively. SFSafariViewController / Custom Tabs keeps
 * the session cookies and returns the user to the app cleanly.
 *
 * @param {string} url
 * @param {{ onClose?: () => void }} [options]
 */
export async function openExternal(url, { onClose } = {}) {
  if (!IS_NATIVE) {
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }

  const { Browser } = await loadBrowser();
  if (onClose) {
    const handle = await Browser.addListener("browserFinished", () => {
      handle.remove();
      onClose();
    });
  }
  await Browser.open({ url, presentationStyle: "popover", toolbarColor: "#1a1a1a" });
}
